const ENDPOINT = new Map();

ENDPOINT.set('fetch', '/administration/course/stats/date/result/fetch');

export default ENDPOINT
